import React, { useState } from "react";

import { MemberInfo } from "../../../types/member";

import { updateNickname } from "../../../services/memberServices";

import useNickName from "../../../hooks/useNickName";
import useFullScreenLoading from "../../../hooks/useFullScreenLoading";

import CommonPopup from "..";
import CommonButton from "../../Button";
import HorizontalRule from "../../Rule/Horizontal";

type Props = {
  popup: string;
  onClose?: (status: number) => void;
  memberInfo?: MemberInfo;
  onLoad?: () => void;
};

export default function ChangeNicknamePopup({
  popup,
  onClose,
  memberInfo,
  onLoad,
}: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [
    {
      data: nickNameData,
      isComplete: isCompleteNickName,
      reset: nickNameDuplicationCheckReset,
      validate: nickNameDuplicationCheckValidate,
    },
    nickNameVerificationComponent,
  ] = useNickName({});
  const loadingComponent = useFullScreenLoading({ isLoading });

  return (
    <CommonPopup
      isOpen={"changeNickname" === popup}
      onClose={() => {
        onClose?.(-1);
        nickNameDuplicationCheckReset();
      }}
      title={"별명 변경"}
      padding={0}
      unUseHorizonRule
    >
      {loadingComponent}
      <div className="flex flex-col px-5 pb-16">
        <div className=" text-2xl font-light leading-[48px] tracking-[-1.04px]">
          <span className="font-medium">원하시는 별명</span>을 써주세요.
        </div>
        <div className=" text-xs text-brand-neutral-50">
          * 별명은 커뮤니티(샌디 Talk) 활동에 사용됩니다.
        </div>
        <HorizontalRule className="bg-black" />
        <div className="flex flex-col gap-2">
          <div className=" text-sm text-brand-neutral-60">현재 별명</div>
          <div className=" text-lg font-medium">{memberInfo?.nickname}</div>
        </div>
        <HorizontalRule />
        {nickNameVerificationComponent}
      </div>

      <div className="flex">
        <CommonButton
          variant="secondary"
          className="w-[100px] rounded-none h-bottom-button"
          onClick={() => {
            onClose?.(-1);
            nickNameDuplicationCheckReset();
          }}
        >
          취소
        </CommonButton>
        <CommonButton
          className="flex-1 rounded-none h-bottom-button"
          validation={!isCompleteNickName}
          onClick={async () => {
            if (!nickNameDuplicationCheckValidate()) return;
            setIsLoading(true);
            const result = await updateNickname({
              nickname: nickNameData.nickname,
            });
            await onLoad?.();
            setIsLoading(false);
            onClose?.(result.status);
            nickNameDuplicationCheckReset();
          }}
        >
          변경 완료
        </CommonButton>
      </div>
    </CommonPopup>
  );
}
